<template>
  <Section :content="bigData" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionBigData',
  components: {
    Section,
  },
  data() {
    return {
      bigData: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Big Data',
        paragraphs: [
          'With the open source Apache Solr database, trusted by Apple, Duckduckgo, Salesforce and many others, we can easily scale for both request frequency and data quantity into the trillions of objects only limited by servers added to the network.'
        ],
        id: 'big-data',
        image: 'apache-logos.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
    }
  }
};
</script>
